import styled from "@emotion/styled"
import { Divider } from "@material-ui/core"
import { empleoTheme } from "config/theme"

export const StyledDivider = styled(Divider)`
  background-color: ${empleoTheme.colors.white};
  height: "0.1rem";
`
